<template>
  <div class="container">
    <div>
      <svg
        class="logo"
        viewBox="0 0 409 77"
        xmlns="http://www.w3.org/2000/svg"
      >
        <!-- eslint-disable-next-line max-len -->
        <path d="M19.988 59.689V19.03H7.592v42.3c0 2.825-.913 4.74-3.739 4.74-.979 0-1.956-.092-2.918-.274L.389 76.463c1.326.215 2.666.337 4.01.363 11.397 0 15.589-6.654 15.589-17.137zm36.83 2.46h12.125V18.94H56.454v24.066c0 5.47-3.282 9.208-8.568 9.208-4.558 0-6.564-3.008-6.564-7.475V18.939h-12.4v29.263c0 9.39 4.195 15.224 12.4 15.224 6.836 0 12.124-4.376 14.584-12.763h.912V62.15zm33.277-24.066c0-5.378 3.374-9.116 8.66-9.116 4.466 0 6.565 3.008 6.565 7.384V62.15h12.396V38.083c0-5.378 3.282-9.116 8.57-9.116 4.56 0 6.563 3.008 6.563 7.384V62.15h12.489V32.887c0-9.39-4.284-15.133-12.76-15.133-7.113 0-12.036 4.467-14.406 12.945h-1.002c-.548-8.114-4.284-12.945-11.942-12.945-6.837 0-12.033 4.375-14.495 12.763h-.913V18.939H77.697v43.21h12.399V38.084zm105.753 2.552c0-14.858-5.381-22.88-14.862-22.88-6.928 0-11.668 4.557-13.946 12.124h-.82v-10.94H153.82v57.067h12.399v-25.16h.728c2.188 7.566 6.838 12.58 14.038 12.58 9.299 0 14.862-7.93 14.862-22.79zM174.97 52.486c-5.286 0-8.75-4.01-8.75-10.028v-3.373c0-6.198 3.372-10.118 8.842-10.118 5.924 0 8.569 3.738 8.569 11.668 0 7.932-2.645 11.851-8.66 11.851zm55.976-15.953l11.487-2.188c-1.55-10.484-7.019-16.59-19.874-16.59-13.764 0-22.15 8.66-22.15 23.336 0 14.768 8.568 22.335 22.243 22.335 12.306 0 18.415-6.29 19.873-16.318l-11.395-2.734c-.912 4.466-3.01 8.204-8.57 8.204-6.38 0-9.481-4.467-9.481-12.125 0-8.204 3.556-11.85 9.298-11.85 5.47 0 7.475 3.28 8.569 7.93zm31.09-32.909h-12.399V62.15h12.4V3.624zm29.172 59.802c13.765 0 22.151-8.66 22.151-22.882 0-14.404-8.66-22.79-22.151-22.79-13.765 0-22.335 8.386-22.335 22.79 0 14.221 8.296 22.882 22.335 22.882zm-.092-35.28c6.838 0 9.847 4.467 9.847 12.307 0 7.84-2.919 12.398-9.847 12.398-7.018 0-9.845-4.558-9.845-12.398s3.009-12.306 9.845-12.306zm56.613 34.004h12.125V18.94h-12.488v24.065c0 5.47-3.283 9.208-8.569 9.208-4.558 0-6.564-3.008-6.564-7.475V18.939h-12.4v29.263c0 9.39 4.195 15.224 12.4 15.224 6.836 0 12.124-4.376 14.584-12.763h.912V62.15zm48.412 0h12.397V3.624H396.14V29.88h-.822c-2.278-7.567-6.929-12.125-13.855-12.125-9.483 0-14.95 8.114-14.95 23.155 0 14.586 5.467 22.517 14.766 22.517 7.202 0 11.943-5.014 14.13-12.58h.731V62.15zm-8.753-9.664c-6.108 0-8.75-3.828-8.75-11.577 0-8.113 2.734-11.942 8.66-11.942 5.469 0 8.843 4.01 8.843 10.301v3.374c0 6.016-3.556 9.844-8.753 9.844zM20.474 6.858a6.684 6.684 0 11-13.369 0 6.684 6.684 0 0113.37 0z" />
      </svg>
      <h1 class="heading">
        Loading Error
      </h1>
      <p class="message">
        Something's not working right. Let us know about it:
        <a
          class="link"
          href="mailto:support@jumpcloud.com?subject=Console Load Error"
          target="_blank"
        >support@jumpcloud.com</a>.
      </p>
      <a
        class="link link--large"
        href="/"
      >
        <svg
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        ><polygon points="8 0 9.41 1.41 3.83 7 16 7 16 9 3.83 9 9.41 14.59 8 16 0 8" /></svg>
        Back to JumpCloud
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadError',
};
</script>

<style>
@value (jcPrimary) from '~css/brand-colors.css';

.jc-body {
  background-color: #f0fcfd;
  color: jcGrey800;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    'Open Sans',
    'Helvetica Neue',
    sans-serif;
  margin: 0;
}

.container {
  margin: auto;
  max-width: 34rem;
  padding: 4rem 2rem;
}

.logo {
  height: 1.5rem;
  margin-bottom: 1rem;
  width: auto;
}

.heading {
  font-size: 4rem;
  font-weight: 900;
  margin: 0 0 2rem;
}

.message {
  font-size: 1.25rem;
  line-height: 1.5;
  margin-bottom: 4rem;
}

.link {
  color: jcPrimary;
  text-decoration: none;
}

.link--large {
  font-size: 1.25rem;
}

.link:hover {
  text-decoration: underline;
}

.link svg {
  bottom: -0.125em;
  fill: currentColor;
  height: 1em;
  position: relative;
  width: 1em;
}

@media screen and (min-width: 40rem) {
  .container {
    display: flex;
  }
}
</style>
